import axios from "axios";
import Config from "../../../config/config";

/**
 * Autoriza desconto com CPF/senha de Gerente, Subgerente ou Backoffice.
 * Body: { cpf, password, motivo, escopo, modo, valor, referenciaItem? }
 */
const v2_actionAutorizarDesconto = (payload) => {
  return axios({
    method: "post",
    url: `${Config.dev ? Config.api_dev : Config.api_prod}/api/v2/apps/pdv/descontos/autorizar`,
    data: payload,
  });
};

export default v2_actionAutorizarDesconto;
